import { Row, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "../../../assets/icons/close-with-shadow.svg";
import AvatarComponent from "../../../components/AvatarComponent";
import { ILive } from "../../../helpers/types";
import { clearStreamStats } from "../../../redux/lives/liveDataSlice";
import { clearLiveData } from "../../../redux/lives/livesSlice";
import { AppDispatch } from "../../../redux/store";
import { APP_DOMAIN } from "../../../utls/constants";

interface Props {
  live: ILive | null;
}

export const FanLiveRTMPHeader = (props: Props) => {
  const { live } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fromPaymentPage = searchParams.get("from");

  const onClickClose = () => {
    dispatch(clearLiveData());
    dispatch(clearStreamStats());
    if (fromPaymentPage) {
      navigate("/p/fan/lives?tab=now");
    } else navigate(-1);
  };

  const navigateToProfile = () => {
    navigate("/p/" + live?.creator?.username);
  };
  return (
    <Row className="justify-content-between pl-15 pr-3 z-fan-live" align="middle">
      {live && (
        <Space className="header-container-left-live gap-1">
          <AvatarComponent image={live?.creator?.avatar} size={30} onClick={navigateToProfile} />
          <Typography.Text className="fullname" onClick={navigateToProfile}>
            {APP_DOMAIN.toUpperCase()}
          </Typography.Text>
        </Space>
      )}
      <Space className={`gap-20 `}>
        <img src={CloseIcon} width={22} alt="close" onClick={onClickClose} />
      </Space>
    </Row>
  );
};
